module.exports = __webpack_public_path__ + "img/bg-intro-right.jpg?b10858b83405905f1828994baf7f90bb";